import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { QRCodeSVG } from 'qrcode.react';
import { mobilizeiAppPublicationsService } from '../_services/mobilizei/appPublications.service';
import { apiErrorMessage } from '../_helpers/apiError';

const useStyles = makeStyles(() => ({
    qrContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0' },
    link: { marginTop: 10, color: '#1976d2', wordBreak: 'break-all', textAlign: 'center', fontSize: 13 },
    warning: { color: '#e65100', fontSize: 13, marginTop: 12 },
    question: { marginTop: 20, padding: '12px 16px', background: '#f5f5f5', borderRadius: 6 },
    questionText: { fontWeight: 'bold', marginBottom: 4 },
    hint: { color: '#555', fontSize: 13, marginBottom: 8 },
}));

export default function RegisterDeviceStep({ store, platformId, formData, handleChangeData, isFinished }) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [registrationUrl, setRegistrationUrl] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        mobilizeiAppPublicationsService
            .registerIosDevice({ storeId: store.id, platformId: platformId || store.platformId })
            .then((res) => setRegistrationUrl(res.registrationUrl))
            .catch((e) => setError(apiErrorMessage(e, 'Erro ao gerar o link de registro.')))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        isFinished(formData.addedNewIosDevice !== '');
    }, [formData.addedNewIosDevice]);

    const handleRadio = (e) => {
        handleChangeData('addedNewIosDevice', e.target.value === 'true');
    };

    const radioValue = formData.addedNewIosDevice === '' ? '' : String(formData.addedNewIosDevice);

    return (
        <Box>
            <Typography variant="body2" style={{ marginBottom: 12 }}>
                Para instalar o IPA de homologação (Ad Hoc), o device deve ter o UDID registrado na conta Apple
                desta loja. Peça ao tester para abrir o link ou escanear o QR Code no iPhone e instalar o perfil.
            </Typography>

            {loading && <Box display="flex" justifyContent="center" mt={3}><CircularProgress /></Box>}

            {error && <Typography variant="body2" style={{ color: '#c62828' }}>{error}</Typography>}

            {registrationUrl && (
                <>
                    <div className={classes.qrContainer}>
                        <QRCodeSVG value={registrationUrl} size={160} />
                        <a className={classes.link} href={registrationUrl} target="_blank" rel="noreferrer">
                            {registrationUrl}
                        </a>
                    </div>

                    <Typography variant="body2" className={classes.warning}>
                        ⚠️ A Apple pode levar até 24–72h para processar um device recém-registrado.
                        Devices em "Processing" ainda não podem ser incluídos no perfil Ad Hoc.
                    </Typography>

                    <div className={classes.question}>
                        <Typography variant="body2" className={classes.questionText}>
                            Você adicionou um novo dispositivo para testes nesta sessão?
                        </Typography>
                        <Typography variant="body2" className={classes.hint}>
                            Se sim, as credenciais iOS serão regeneradas para incluir o novo UDID no perfil Ad Hoc.
                        </Typography>
                        <RadioGroup value={radioValue} onChange={handleRadio}>
                            <FormControlLabel value="true" control={<Radio color="primary" />} label="Sim, adicionei um novo device" />
                            <FormControlLabel value="false" control={<Radio color="primary" />} label="Não, apenas consultei o link" />
                        </RadioGroup>
                    </div>
                </>
            )}
        </Box>
    );
}
